import queryString from "query-string";
import {
  setStoreItemsCopy,
  updateStoreItemCopy,
  removeStoreItemCopy,
  addStoreCopy,
} from "./appifyActions";
import { privateFetch } from "apis";
import { removeEmptyParams, SecureLocalStorage } from "helpers";

// StoreItem Action Dispatchers
export const setStoreSettings = (storeSettings) => ({
  type: "SET_STORE_SETTINGS",
  storeSettings,
});

export const removeStoreSettings = () => ({
  type: "REMOVE_STORE_SETTINGS",
});

// GET store settings associated with an appId
export const getStoreSettings = (appId) => (dispatch) => {
  const url = __BASE_API_URL__ + `/app/${appId}/storeSettings`;

  return privateFetch(url, {
    method: "GET",
  }).then((storeSettings) => {
    dispatch(setStoreSettings(storeSettings));
    return storeSettings;
  });

  //
};

// UPDATE StoreSettings
export const updateStoreSettings = (storeSettings, appId) => (dispatch) => {
  const url =
    __BASE_API_URL__ + `/app/${appId}/storeSettings/${storeSettings.id}`;
  console.log("MAKING API CALL with Object: ");

  console.log(storeSettings);
  return privateFetch(url, {
    method: "PUT",
    body: JSON.stringify(storeSettings),
  }).then((storeSettings) => {
    dispatch(setStoreSettings(storeSettings));
    return storeSettings;
  });
};
